<div class="page-container rb-chatbot container w-100 pt-2">
  <h1 class="header col-12 mt-3 mb-3">
    RightBRIDGE Chatbot

    <button type="button" matButton color="warn" (click)="resetChat()">
      <mat-icon>reset_tv</mat-icon> Restart Chat
    </button>
  </h1>

  <div class="row chatbot-container">
    <div class="col-md-7 col-12 card-container">
      <div class="info-card mb-4 w-100 p-0">
        <div class="card-header"> Chat Center </div>

        <div class="card-info">
          <div class="chat-center">
            <div class="chat-messages-container">
              @if (messages.length > 0) {
                @for (
                  message of messages;
                  track message.NoteId;
                  let i = $index
                ) {
                  <div
                    class="chat-message"
                    [ngClass]="{
                      incoming: message.CreatedByUserId !== defaultUser.id,
                      'top-message': i === 0,
                    }"
                  >
                    <div class="sender-info">
                      {{ message.CreateDate | date: 'medium' }}
                    </div>
                    <div class="chat-bubble mb-2">
                      <span [innerHTML]="message.NoteText"></span>
                    </div>
                  </div>
                }
              } @else if (messages.length <= 0 && !responseLoading) {
                <div class="no-chat-container"> No messages found </div>
              }
              @if (responseLoading) {
                <div class="chat-message incoming response-loading">
                  <div class="chat-bubble mb-2">
                    <app-simple-loading />
                  </div>
                </div>
              }
            </div>
            <div class="chat-input">
              <form (submit)="submitNote()">
                <div class="input-container">
                  <div class="input-items">
                    <div class="input-editor">
                      <textarea
                        rows="1"
                        id="chatInput"
                        matInput
                        type="text"
                        placeholder="Message"
                        name="Message"
                        [(ngModel)]="message"
                        (keydown.enter)="checkSubmit($event)"
                      ></textarea>

                      <div class="input-disclaimer">
                        Shift + Enter starts a new line.
                      </div>
                    </div>

                    <span class="input-buttons">
                      @if (canSpeechToText) {
                        <app-speech-to-text
                          #speechToText
                          [speechReviewed]="true"
                          [typedText]="message"
                          [externalTriggerStop]="externalTriggerStop"
                          (text)="applySpeechToTextNote($event)"
                          (noteSpeechError)="applySpeechToTextError($event)"
                        />
                      }
                      <button
                        class="mx-2"
                        mat-mini-fab
                        aria-label="Submit Note"
                        color="primary"
                        type="submit"
                        [disabled]="
                          !message ||
                          message === '<p></p>' ||
                          responseLoading ||
                          voiceUsed
                        "
                      >
                        <mat-icon>send</mat-icon>
                      </button>
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-5 col-12 card-container">
      <div class="info-card mb-4 w-100 p-0">
        <div class="card-header">Captured Data</div>

        <div class="card-info">
          @if (capturedData && !error) {
            <div class="captured-data">
              <markdown [data]="capturedData" />

              @if (responseLoading) {
                <app-simple-loading [message]="'Processing data...'" />
              }
            </div>
          } @else if (!capturedData && responseLoading) {
            <div class="data-loading">
              <app-simple-loading [message]="'Capturing data...'" />
            </div>
          } @else if (!responseLoading && error) {
            <div class="error-message">
              <span> Oops! Something went wrong, please try again. </span>
            </div>
          } @else {
            <div class="no-response">
              <span> Captured data will show here. </span>
            </div>
          }
        </div>

        <div class="action-buttons-container">
          <button
            type="button"
            matButton
            color="warn"
            class="me-2"
            [disabled]="responseLoading"
            (click)="cancelChat()"
          >
            <mat-icon>close</mat-icon> Cancel & Exit
          </button>

          <button
            type="button"
            matButton="elevated"
            color="accent"
            [disabled]="!capturedData || responseLoading"
            (click)="saveAndExit()"
          >
            <mat-icon>save</mat-icon> Save & Exit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
